module.exports = __webpack_public_path__ + "img/Spirale_spazio.54c43bae.svg";